var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 17,
    viewBox: "0 0 512 512",
    width: 17,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m426.495 228.411v-43.482h52.21l-57.333-133.286h-364.039l-57.333 133.286h52.21v206.571h234.055c18.755 40.607 59.862 68.857 107.448 68.857 65.224 0 118.286-53.063 118.286-118.286.001-53.853-36.176-99.412-85.504-113.66zm-24.877-146.768 31.524 73.286h-139.484l-31.524-73.286zm-324.531 0h139.484l-31.524 73.286h-139.484zm5.123 103.286h122.591l19.552-45.453v222.024h-142.143zm172.143 176.571v-222.025l19.552 45.453h122.591v38.893c-.925-.021-1.851-.035-2.781-.035-65.223 0-118.285 53.063-118.285 118.285 0 6.617.555 13.105 1.604 19.429zm139.361 68.857c-48.681 0-88.285-39.604-88.285-88.286 0-48.681 39.604-88.285 88.285-88.285 48.682 0 88.286 39.604 88.286 88.285 0 48.682-39.604 88.286-88.286 88.286z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383.77 349.233-26.254-26.254-21.213 21.213 47.467 47.467 67.355-67.356-21.213-21.213z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.714 292.643h30v30h-30z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiving);
export default __webpack_public_path__ + "static/media/receiving.730506bca51417efbae8279c055ff074.svg";
export { ForwardRef as ReactComponent };